import React from 'react';
import { Button, Icon } from '@kontentino/ui';
import { faMusic } from '@fortawesome/pro-regular-svg-icons/faMusic';
import { useTranslation } from 'react-i18next';
import InstagramAudioDisabledTooltip from './InstagramAudioDisabledTooltip';

interface InstagramAudioEmptyStateProps {
  isDisabled?: boolean;
  disabledReason?: string | null;
  onOpenPicker: () => void;
}

const InstagramAudioEmptyState = ({
  isDisabled,
  disabledReason,
  onOpenPicker,
}: InstagramAudioEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <InstagramAudioDisabledTooltip reason={isDisabled ? disabledReason : null}>
      <Button
        variant="ghost"
        size="small"
        disabled={isDisabled}
        iconBefore={<Icon icon={faMusic} size="sm" />}
        onClick={onOpenPicker}
        className="tw-border tw-border-dashed tw-border-grayscale-50 tw-bg-transparent tw-text-grayscale-180 hover:tw-bg-grayscale-10"
        data-cy="instagram-audio_open-picker-button"
      >
        {t('instagramAudio.addAudio')}
      </Button>
    </InstagramAudioDisabledTooltip>
  );
};

export default InstagramAudioEmptyState;
